import styled from 'styled-components';

const StyledItemsListUl = styled.ul`
    list-style : none;
    display: flex; 
    flex-direction: row; 
    justify-content: flex-start; 
    flex-wrap: wrap;
`
export default StyledItemsListUl; 